(function ($, angular) {
    'use strict';
    angular
        .module('sites.menu', [])
        .controller('SitesMenu', ['$scope', '$filter', function ($scope, $filter) {
            $scope.model = {};
            $scope.maxSites = 5;
            $scope.model.siteQuery = '';
            $scope.filter = function () {
                return $filter('filter')($scope.model.sites || [], $scope.model.siteQuery);
            };

            $scope.showMore = function () {
                return $scope.filter().length > $scope.maxSites;
            };
        }]);
    $(function () {
        angular.bootstrap($('#sitesMenu').get(), ['sites.menu']);

        setTimeout(function() {
            var $dropdown = $('li#sitesMenu.dropdown');
            var $toggle = $dropdown.find('>a');

            //Manually do the dropdown trigger because we don't want to dismiss it when clicking on items in the menu
            $toggle.on('click', function (event) {
                var isOpen = $(this).parent().toggleClass('open').hasClass('open');
                $(this).attr('aria-expanded', String(isOpen));
                return false;
            });

            $toggle.on('keydown', function (evt) {
                if (evt.key === 'Enter' || evt.key === ' ') {
                    evt.preventDefault();
                    var isOpen = $(this).parent().toggleClass('open').hasClass('open');
                    $(this).attr('aria-expanded', String(isOpen));
                }
            });

            $dropdown.on('keydown', function (evt) {
                if (evt.key === 'Escape' && $dropdown.hasClass('open')) {
                    evt.preventDefault();
                    $dropdown.removeClass('open');
                    $toggle.attr('aria-expanded', 'false');
                    $toggle.focus();
                }
            });

            // Safari doesn't focus links/buttons on click, which causes focusout
            // to fire and close the dropdown before the click event registers.
            // Track mousedown inside the dropdown to prevent premature closing.
            $dropdown.on('mousedown', function () {
                $dropdown.data('clicking', true);
            });

            $dropdown.on('focusout', function (evt) {
                setTimeout(function () {
                    if ($dropdown.data('clicking')) {
                        $dropdown.data('clicking', false);
                        return;
                    }
                    if (!$dropdown[0].contains(document.activeElement)) {
                        $dropdown.removeClass('open');
                        $toggle.attr('aria-expanded', 'false');
                    }
                }, 0);
            });

            $('body').on('click', function (e) {
                if (!$dropdown.is(e.target)
                    && $dropdown.has(e.target).length === 0
                    && $('.open').has(e.target).length === 0
                ) {
                    $dropdown.removeClass('open');
                    $toggle.attr('aria-expanded', 'false');
                }
            });
        }, 0);

    });
})(window.jQuery, window.angular);
